module.exports = __webpack_public_path__ + "static/media/bfj.378723e4.gif";